import { useNavigate } from 'react-router';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { useRequestedPlan } from '#hooks/useRequestedPlan.ts';
import { useTimeout } from '#hooks/useTimeout.ts';

/**
 * Shared "MFA enrollment finished" redirect, used by every first-time setup
 * step (passkey and TOTP). The short delay lets the enrollment form show its
 * success state before we navigate away. Pro signups continue to checkout;
 * everyone else returns to where they came from.
 */
export function useMFAEnrollmentRedirect() {
  const navigate = useNavigate();
  const location = useAppLocation();
  const [plan, clearPlan] = useRequestedPlan();

  const { start: redirectAfterDelay } = useTimeout(() => {
    void navigate(location.state?.from ?? '/', { replace: true });
  }, 1000);

  const { start: redirectToProCheckout } = useTimeout(() => {
    void navigate('/signup/pro', { replace: true });
  }, 1000);

  return function onEnrolled() {
    clearPlan();
    plan === 'pro' ? redirectToProCheckout() : redirectAfterDelay();
  };
}
